import React, { useLayoutEffect, useMemo, useRef } from "react";
import FieldOverlay from "./FieldOverlay";

const MemoFieldOverlay = React.memo(FieldOverlay);
const eventNames = [
  "onFocus",
  "onMouseDown",
  "onBlur",
  "onChange",
  "onClick",
  "onCheckboxOverlayClick",
  "onFavouriteDrop",
];

// Keep event identities stable without retaining old field/selection closures.
// All non-event props still participate in React.memo's normal comparison.
const StableFieldOverlay = (props) => {
  const committedProps = useRef(props);
  useLayoutEffect(() => {
    committedProps.current = props;
  });
  const events = useMemo(
    () =>
      Object.fromEntries(
        eventNames.map((name) => [
          name,
          (...args) => committedProps.current[name]?.(...args),
        ]),
      ),
    [],
  );
  const nextProps = { ...props };
  for (const name of eventNames) {
    nextProps[name] =
      typeof props[name] === "function" ? events[name] : props[name];
  }
  return <MemoFieldOverlay {...nextProps} />;
};

export default StableFieldOverlay;
